import styled, { css } from "styled-components";

import { COLOR, TEXT_COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { setFontStyle } from "@sellernote/ui/src/sds-v2/styles/typography";
import { mobile } from "@sellernote/ui/src/styles/functions";

const utilityCard = styled.li<{ sequence: number }>`
  .utility-card {
    width: 360px;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${COLOR.wh};
    border-radius: 4px;

    ${mobile(css<{ sequence: number }>`
      ${({ sequence }) =>
        sequence % 2 === 1
          ? css`
              width: 348px;
            `
          : css`
              width: 352px;
            `}
    `)}
  }

  &:nth-child(1) {
    animation-delay: 0.2s;
  }
  &:nth-child(2) {
    animation-delay: 0.4s;
  }
  &:nth-child(3) {
    animation-delay: 0.6s;
  }
`;

const utilityCardHeader = styled.header<{
  sequence: number;
}>`
  padding: 24px 24px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${COLOR.wh};
  border-radius: 4px 4px 0px 0px;

  ${mobile(css<{ sequence: number }>`
    ${({ sequence }) => {
      if (sequence === 1) {
        return css`
          padding: 24px 20px 12px 16px;
        `;
      }

      if (sequence === 2) {
        return css`
          padding: 24px 20px 12px 20px;
        `;
      }

      if (sequence === 3) {
        return css`
          padding: 24px 16px 12px 20px;
        `;
      }
    }}
  `)}

  .utility-card-title {
    ${setFontStyle("Head6")};
    color: ${TEXT_COLOR.black_2};
  }

  .utility-card-description {
    ${setFontStyle("Body3")};
    color: ${TEXT_COLOR.black_3};
  }
`;

export default {
  utilityCard,
  utilityCardHeader,
};
